define.alias("shared/components/shared/ui/past-post-limit-banner", "preview-grid/components/shared/ui/past-post-limit-banner");